import { call, put, takeEvery } from "redux-saga/effects";
import * as CouponService from "../../../api/couponsApi";
import { CREATE_COUPON_FOR_PEP_REQUEST, CreateCouponForPepAction, createCouponForPepFailed, createCouponForPepSuccess } from "../actions";
import { datadogRum } from "@datadog/browser-rum";

export function* createCouponForPEP(action: CreateCouponForPepAction) {
  const { payload } = action;
  datadogRum.addAction("[createCouponForPEP saga] hitting coupon endpoint", payload);
  try {
    const { data } = yield call(CouponService.requestCouponForPep, payload);
    datadogRum.addAction("[createCouponForPEP saga] received response from coupon endpoint", data);
    yield put(createCouponForPepSuccess(data));
  } catch (error) {
    datadogRum.addError("[createCouponForPEP saga] error", error);
    yield put(createCouponForPepFailed(error));
  }
}

export function* watchCreateCouponForPep() {
  yield takeEvery(CREATE_COUPON_FOR_PEP_REQUEST, createCouponForPEP);
}
